var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissingStatusReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4563 5.23125L10.5188 1.29375C10.4063 1.18125 10.2937 1.125 10.125 1.125H4.5C3.88125 1.125 3.375 1.63125 3.375 2.25V15.75C3.375 16.3687 3.88125 16.875 4.5 16.875H13.5C14.1187 16.875 14.625 16.3687 14.625 15.75V5.625C14.625 5.45625 14.5688 5.34375 14.4563 5.23125ZM10.125 2.475L13.275 5.625H10.125V2.475ZM13.5 15.75H4.5V2.25H9V5.625C9 6.24375 9.50625 6.75 10.125 6.75H13.5V15.75Z",
    fill: "#212B36",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 12.375H12.375V13.5H5.625V12.375ZM5.625 9H12.375V10.125H5.625V9Z",
    fill: "#212B36",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingStatusReportIcon);
export default __webpack_public_path__ + "static/media/missing-status-report-icon.1870f674ba652ac28be6065ce24cdeba.svg";
export { ForwardRef as ReactComponent };